import React, { useRef, useState } from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore, useFetchRemoteData } from '@vt/hooks'
import styled from '@emotion/styled'
import { ArticleSort, Article as ArticleList, OtherArticle } from '@ow/ditto'
import Detail from './detail/use-details-modal'

const StyledArticle = styled.div`
  width: ${({ isSimpleList }) => {
    return isSimpleList ? '100%' : '100%'
  }};
`

const Article = function () {
  const { articleConfig, tbData, fields, setSorts, tbId, pageNum, listConfig } =
    useTbViewStore((state) =>
      pick(state, [
        'articleConfig',
        'tbData',
        'fields',
        'setSorts',
        'tbId',
        'pageNum',
        'listConfig',
      ])
    )
  const { side = {}, isSimpleList } = articleConfig
  const fetchRemoteData = useFetchRemoteData()
  const detailRef = useRef()
  const [detailData, setData] = useState()

  const openDetail = (data) => {
    setData(data)
    detailRef.current.open()
  }

  return (
    <StyledArticle
      className="mx-auto overflow-hidden flex flex-1 flex-col"
      isSimpleList={isSimpleList}
    >
      {listConfig && (
        <ArticleSort fields={listConfig.fields || []} setSorts={setSorts} />
      )}
      <div
        className="flex justify-between overflow-y-auto"
        style={{ marginTop: '12px' }}
      >
        <ArticleList
          articleConfig={articleConfig}
          pageNum={pageNum}
          articleData={tbData}
          tbFields={fields}
          openDetail={openDetail}
        />
        {side.show && (
          <OtherArticle
            articleConfig={articleConfig}
            tbId={tbId}
            fetchRemoteData={fetchRemoteData}
            tbFields={fields}
          />
        )}
      </div>
      <Detail
        closeModal={() => {
          setData({})
        }}
        data={detailData}
        ref={detailRef}
      />
    </StyledArticle>
  )
}
export default Article
